import { SSO_URL } from '../../../config'

export const doSsoRedirect = () => location.replace(`${SSO_URL}?appName=hof&sso_return=${location.href}`)
